module.exports = __webpack_public_path__ + "static/img/rygl.f3f57a13.png";